import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
  .preview-player-control {
    display: inline-block;
  }

  .preview-control {
    display: flex;
    align-items: center;
    border-radius: 50%;
    padding: 0;
    border: 0;
    background: transparent;
    color: ${colors.primaryText};
    opacity: 0;
  }

  .preview-control:not(.disabled) {
    cursor: pointer;
  }

  .preview-control.show {
    -webkit-animation: 1.5s ease 0s normal forwards 1 fadein;
      animation: 1.5s ease 0s normal forwards 1 fadein;
  }

  @keyframes fadein{
    0% { opacity:0; }
    66% { opacity:0; }
    100% { opacity:1; }
  }

  @-webkit-keyframes fadein{
    0% { opacity:0; }
    66% { opacity:0; }
    100% { opacity:1; }
  }
`
